import crud from './helpers/crud';
import join from 'url-join';
import { servletSave } from './helpers';

export default class SchoolSourceDAO extends crud {
  constructor(urls) {
    super(urls.SCHOOL_SOURCES_URL);
    this.SCHOOL_SOURCES_URL = urls.SCHOOL_SOURCES_URL;
  }

  match({ sourceId, tokenSchools }) {
    return servletSave(join(this.SCHOOL_SOURCES_URL, 'match'), { sourceId, tokens: tokenSchools });
  }
}


// WEBPACK FOOTER //
// ./src/js/util/dao/SchoolSourceDAO.js